import type { JobListItemViewModel } from '@/entities/job';

import type { JobSummaryDto, JobSummaryType } from './job-summary.dto';
import type { AutoProcessAtsVacancyResultDto } from './auto-process-ats-vacancy.dto';
import { getJobIdentifier } from './get-job-identifier';

export type JobSummaryViewModel = {
  dbId: number | null;
  jobAtsId: string;
  jobCampaignId: string | null;
  jobIndeedId: string | null;
  jobTitle: string | null;
  qualityPercent: number | null;
  isImproved: boolean;
  type: JobSummaryType;
  createdAt: string;
  updatedAt: string;
  originJobTitle?: string | null;
  name: string;
};

export const toJobSummaryViewModel = (dto: JobSummaryDto): JobSummaryViewModel => ({
  dbId: dto.db_id,
  jobAtsId: dto.job_ats_id,
  jobCampaignId: dto.job_campaign_id,
  jobIndeedId: dto.job_indeed_id,
  jobTitle: dto.job_title,
  qualityPercent: dto.quality_percent,
  isImproved: dto.is_improved,
  type: dto.type,
  createdAt: dto.created_at,
  updatedAt: dto.updated_at,
  originJobTitle: dto.origin_job_title,
  name: dto.origin_job_title ?? dto.job_title ?? '',
});

export const toJobSummaryViewModelFromAutoProcessResult = (
  result: AutoProcessAtsVacancyResultDto,
): JobSummaryViewModel => ({
  dbId: result.id,
  jobAtsId: result.job_ats_id ?? '',
  jobCampaignId: result.job_campaign_id,
  jobIndeedId: result.job_indeed_id,
  jobTitle: result.job_details?.job_title ?? null,
  qualityPercent: result.quality_percent,
  isImproved: true,
  type: result.type as JobSummaryType,
  createdAt: result.created_at,
  updatedAt: result.updated_at,
  originJobTitle: result.origin_job_title,
  name: result.origin_job_title ?? result.job_details?.job_title ?? '',
});

export const toJobListItemViewModel = (summary: JobSummaryViewModel): JobListItemViewModel => ({
  id: getJobIdentifier(summary),
  name: summary.name,
  quality: summary.qualityPercent,
  type: summary.type,
  isImproved: summary.isImproved,
});
